export default "__VITE_ASSET__C_QoS1T1__"